module.exports = window.Vue;